import { render, staticRenderFns } from "./CustomerEditDrawer.vue?vue&type=template&id=0a83705c"
import script from "./CustomerEditDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerEditDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports